import {
  getPrototypeOf,
  isArray,
  isTerminateValue,
  objectPrototype
} from '@rehaje/shared'

export function isExposedNeedProxy(target: any) {
  if (!target || isTerminateValue(target) || target.__r_proxy_raw) return false
  return isArray(target) || getPrototypeOf(target) === objectPrototype
}
